import { useEffect, useState } from 'react';

import { TaskResponse } from '../client';

export function useTaskCompletedEffect(task: TaskResponse, onTaskCompleted: (task: TaskResponse) => Promise<void>) {
  const [gameWon, setGameWon] = useState<boolean>(task.completed_effort >= task.total_effort);

  useEffect(() => {
    if (task.completed_effort >= task.total_effort && !gameWon) {
      setGameWon(true);
      onTaskCompleted(task);
    }
  }, [task, gameWon, onTaskCompleted]);

  return gameWon;
}
